import { ArrowLeftIcon } from "@phosphor-icons/react";
import { fmtCell, fmtNum, fmtInt, fmtMoney, unitsText } from "./format";

const TIPO = { factura: "Factura", contado: "Contado", devolucion: "NC devolución", descuento: "NC descuento", ajuste: "NC ajuste", bono: "NC bono", otro: "NC" };

/** Nivel FACTURA del drill-down: número, fecha, cliente, producto, presentación, cantidad, precio, total. */
export default function DrillTable({ drill, onBack }) {
  const t = drill.totals || {};
  return (
    <div data-testid="view-drill">
      <div className="px-4 py-3 border-b border-border/40 flex items-center justify-between flex-wrap gap-2">
        <div className="text-xs">
          <span className="text-text-muted">{drill.total_rows} líneas · {t.facturas} facturas</span>
          <span className="ml-3 text-agro-green">{fmtMoney(t.monto)}</span>
          <span className="ml-3">· {t.unidades_mixtas ? unitsText(t.unidades_por_unidad) : `${fmtNum(t.unidades)} unidades`}</span>
          {t.costo_total !== undefined && (
            <span className="ml-3 text-text-muted">· Costo {fmtMoney(t.costo_total)} · Utilidad {fmtMoney(t.utilidad)} · Margen {fmtNum(t.margen)}%</span>
          )}
          {drill.periodo?.i > 0 && <span className="ml-3 text-amber-300">Período comparable {drill.periodo.desde} a {drill.periodo.hasta}</span>}
        </div>
        <button onClick={onBack} className="text-xs text-agro-green flex items-center gap-1" data-testid="btn-drill-close">
          <ArrowLeftIcon size={12} /> Regresar
        </button>
      </div>
      <div className="overflow-x-auto max-h-[calc(100vh-420px)]">
        <table className="w-full text-sm">
          <thead className="bg-sidebar sticky top-0">
            <tr className="text-left text-[10px] uppercase tracking-wider text-text-muted">
              {drill.columns.map((c) => (
                <th key={c.k} className={`p-2 whitespace-nowrap ${["m", "n", "i", "p"].includes(c.t) ? "text-right" : ""}`}>{c.l}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {drill.rows.map((r, i) => (
              <tr key={i} className={`border-t border-border/30 hover:bg-white/[0.02] ${r.total < 0 ? "text-red-300" : ""}`}>
                {drill.columns.map((c) => (
                  <td key={c.k} className={`p-1.5 px-2 text-xs ${["m", "n", "i", "p"].includes(c.t) ? "text-right tabular-nums" : ""}`}>
                    {c.k === "tipo_doc" ? (TIPO[r[c.k]] || r[c.k]) : fmtCell(r[c.k], c.t)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {drill.total_rows > drill.rows.length && (
          <div className="p-2 text-[11px] text-text-muted text-center">
            Mostrando {fmtInt(drill.rows.length)} de {fmtInt(drill.total_rows)} líneas (los totales incluyen todas).
          </div>
        )}
      </div>
    </div>
  );
}
